import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { InlineSVGModule } from 'ng-inline-svg';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
// Highlight JS
import { HighlightModule, HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';
import { SplashScreenModule } from './_metronic/partials/layout/splash-screen/splash-screen.module';

import { AngularFireModule } from '@angular/fire/compat';
// import {
//   AngularFireAnalyticsModule,
//   APP_VERSION,
//   ScreenTrackingService,
// } from '@angular/fire/analytics';
// import {
//   AngularFirePerformanceModule,
//   PerformanceMonitoringService,
// } from '@angular/fire/performance';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular';

import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TokenInterceptor } from './shared/interceptors/token-interceptor';
import { TimeoutInterceptor } from './shared/interceptors/timeout-interceptor';
import { IonicStorageModule } from '@ionic/storage-angular';
import { ClientErrorHandler } from './shared/services/client-error-handler.service';
import { AppEmbedService } from './shared/services/app-embed.service';
import { AutoRedirectService } from './shared/services/auto-redirect.service';
import { MedRecFormatProviderService } from './shared/pipes/med-record-number.pipe';
import { ApiEncryptionInterceptor } from './shared/interceptors/api-encryption-interceptor';

@NgModule({
  declarations: [AppComponent],
  imports: [
    ApmModule,
    BrowserModule,
    BrowserAnimationsModule,
    SplashScreenModule,
    TranslateModule.forRoot(),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebase),
    // environment.production ? AngularFireAnalyticsModule : [],
    // environment.production ? AngularFirePerformanceModule : [],
    AngularFireMessagingModule,
    HttpClientModule,
    HighlightModule,
    MatSnackBarModule,
    AppRoutingModule,
    InlineSVGModule.forRoot(),
    NgbModule,
  ],
  providers: [
    ApmService,
    { provide: ErrorHandler, useClass: ClientErrorHandler },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TimeoutInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiEncryptionInterceptor,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (...services) => {
        return () => {
          services.forEach((svc) => svc.init());
        };
      },
      multi: true,
      deps: [AppEmbedService, AutoRedirectService, MedRecFormatProviderService],
    },
    // { provide: APP_VERSION, useValue: environment.appVersion },
    // PerformanceMonitoringService,
    // ScreenTrackingService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(apmService: ApmService) {
    if (environment.production) {
      const apm = apmService.init({
        serviceName: 'super-app-klinik',
        serverUrl: 'https://apm.periksa.net',
        environment: environment.type === 'production' ? 'production' : 'staging',
        serviceVersion: environment.appVersion,
      });
    }
  }
}
